// src/pages/legal/Returns.js
import React from 'react';

const Returns = () => {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Remboursements et retours</h1>
        <p className="text-gray-500 mb-8">Dernière mise à jour : 15 Juin 2024</p>
        
        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-3">Délai de rétractation</h2>
            <p className="text-gray-600">Vous disposez d'un délai de 14 jours à compter de la réception de votre commande pour exercer votre droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Conditions de retour</h2>
            <p className="text-gray-600">Les produits doivent être retournés dans leur emballage d'origine, non ouverts et en parfait état. Les produits entamés ou endommagés ne pourront être remboursés. Les frais de retour sont à la charge du client.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Procédure de retour</h2>
            <p className="text-gray-600">Pour retourner un produit, contactez notre service client à contact@aquaexpress.fr avec votre numéro de commande. Nous vous fournirons les instructions de retour.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Remboursement</h2>
            <p className="text-gray-600">Le remboursement sera effectué dans un délai maximum de 14 jours à compter de la réception du produit retourné, selon le même moyen de paiement que celui utilisé pour l'achat.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Produits défectueux</h2>
            <p className="text-gray-600">En cas de produit défectueux ou endommagé lors de la livraison, contactez-nous immédiatement. Nous procéderons à l'échange ou au remboursement sans frais supplémentaires.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Returns;